import type { AccountQuery } from "../schema/index.ts";

/** React Query keys shared by the learner player, the builder and the users page. */
export const queryKeys = {
  session: () => ["session"] as const,
  courses: () => ["courses"] as const,
  course: (slug: string) => ["courses", slug] as const,
  lesson: (courseSlug: string, lessonSlug: string) =>
    ["courses", courseSlug, "lessons", lessonSlug] as const,
  progress: (courseSlug: string) => ["progress", courseSlug] as const,
  admin: {
    all: () => ["admin"] as const,
    courses: () => ["admin", "courses"] as const,
    course: (id: string) => ["admin", "courses", id] as const,
    lesson: (id: string) => ["admin", "lessons", id] as const,
    /** Prefix of every users-page key. */
    roles: () => ["admin", "roles"] as const,
    accountPage: (query: AccountQuery) => ["admin", "roles", query] as const,
  },
};
